// extracted by mini-css-extract-plugin
module.exports = {"cell":"V4Cell_cell__1i4fm","cutout":"V4Cell_cutout__3CXUc"};